export class SeoDataModel {
  title: string;
  description: string;
  keywords: string;
  image: string;
}
